import React, { useEffect } from "react";
import Card from "components/card";
import DataChart from "./components/DataChart";
import CardOverview from "./components/CardOverview";

import BasicLayout from "components/wizard/BasicLayout";
import LicensesDetailTable from "./components/LicensesDetailTable";
import { useStateContext } from "context/ContextProvider";

const Homepage = () => {
    const {
        licenses,
        licensesList,
        serverActivations,
        serverActivationsByMonth,
        getActivations,
        getLicenses,
    } = useStateContext();

    useEffect(() => {
        getLicenses();
        getActivations();
    }, []);

    return (
        <div className="grid grid-cols-1 gap-x-10 gap-y-8 lg:grid-cols-2">
            <Card extra="z-[10] px-3 py-2 md:px-5 md:py-4">
                <BasicLayout
                    title="Licenze"
                    subtitle="Stato attuale del portafoglio licenze e scadenze imminenti."
                    content={
                        <div className="flex flex-wrap gap-x-6 gap-y-4">
                            {licenses.map(
                                ({
                                    id,
                                    title,
                                    value,
                                    icon,
                                    color,
                                    months,
                                    years,
                                }) => (
                                    <React.Fragment key={id}>
                                        <CardOverview
                                            title={title}
                                            value={value}
                                            color={color}
                                            icon={icon}
                                            months={months}
                                            years={years}
                                            className="grow basis-1 lg:max-w-[16rem]"
                                        />
                                    </React.Fragment>
                                )
                            )}
                        </div>
                    }
                />
            </Card>

            <Card extra="z-[10] px-3 py-2 md:px-5 md:py-4">
                <BasicLayout
                    title="Attivazioni server"
                    subtitle="Monitoraggio dei sistemi attivi e processi in attesa."
                    content={
                        <div className="flex flex-wrap gap-x-6 gap-y-4">
                            {serverActivations.map(
                                ({
                                    id,
                                    title,
                                    value,
                                    icon,
                                    color,
                                    months,
                                    years,
                                    onClick,
                                }) => (
                                    <React.Fragment key={id}>
                                        <CardOverview
                                            title={title}
                                            value={value}
                                            color={color}
                                            icon={icon}
                                            months={months}
                                            years={years}
                                            onClick={onClick}
                                            className="grow basis-1 lg:max-w-[16rem]"
                                        />
                                    </React.Fragment>
                                )
                            )}
                        </div>
                    }
                />
            </Card>

            <Card extra="z-[10] px-3 py-2 md:px-5 md:py-4">
                <BasicLayout
                    title="Dettaglio licenze"
                    subtitle="Elenco completo delle istanze con strumenti di gestione."
                    content={<LicensesDetailTable data={licensesList} />}
                />
            </Card>

            <Card extra="z-[10] px-3 py-2 md:px-5 md:py-4">
                <BasicLayout
                    title="Attivazioni ultimo anno"
                    subtitle="Analisi della crescita e distribuzione delle attivazioni."
                    content={
                        <DataChart
                            data={serverActivationsByMonth}
                            absoluteFilters
                            className="!h-[28rem]"
                        />
                    }
                />
            </Card>
        </div>
    );
};

export default Homepage;
